module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }